import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'icon-question-circle',
  templateUrl: './question-circle.component.html',
  styleUrls: ['./question-circle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionCircleComponent {}
